import {
    ISearchingTag,
    TagName,
    TagType,
} from "./../../../shared/components/tag-searching-input/~types/models/SearchingTag";
import i18n from "src/app/shared/localization/i18n";

export const TOPIC_PAIRS_ON_PAGE = 20;

export const getNlpSearchingTags = (
    topicPairCategories: string[],
    topicPairSources: string[]
): ISearchingTag[] => [
    {
        id: 1,
        value: i18n.t("nlp.answer"),
        tagName: TagName.Answer,
        suggestions: ["3"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 2,
        value: i18n.t("nlp.subject"),
        suggestions: ["3", "4"],
        tagType: TagType.OpeningTag,
        tagName: TagName.Subject,
    },
    {
        id: 3,
        value: "=",
        tagType: TagType.OperationTag,
    },
    {
        id: 4,
        tagName: TagName.Subject,
        value: "",
        suggestions: topicPairCategories,
        tagType: TagType.ClosingTag,
    },
    {
        id: 5,
        tagName: TagName.Source,
        value: "",
        suggestions: topicPairSources,
        tagType: TagType.ClosingTag,
    },
    {
        id: 6,
        value: i18n.t("nlp.source"),
        suggestions: ["3", "5"],
        tagType: TagType.OpeningTag,
        tagName: TagName.Source,
    },
    {
        id: 7,
        value: i18n.t("nlp.trigger"),
        tagName: TagName.TriggerName,
        suggestions: ["3", "8"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 8,
        tagName: TagName.TriggerName,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag
    }
];

export const getTriggerNameTags = (triggerName: string): ISearchingTag[] => [
    {
        id: 6,
        value: "Триггер",
        tagName: 100,
        suggestions: ["2"],
        tagType: 0,
        externalValue: "Trigger",
    },
    { id: 2, value: "=", tagType: 2 },
    {
        id: 7,
        tagType: 1,
        value: triggerName,
        tagName: 100,
    },
];
